module.exports = __webpack_public_path__ + "media/images/flags/64/Malaysia-6c390775a1c5f765f9629ed3fdef1788.png";